/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Directory_Ai_Tools_Studio_CreditsInputs */

const en_directory_ai_tools_studio_credits = /** @type {(inputs: Directory_Ai_Tools_Studio_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits`)
};

const zh_directory_ai_tools_studio_credits = /** @type {(inputs: Directory_Ai_Tools_Studio_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} 积分`)
};

/**
* | output |
* | --- |
* | "{credits} credits" |
*
* @param {Directory_Ai_Tools_Studio_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_credits = /** @type {((inputs: Directory_Ai_Tools_Studio_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_credits(inputs)
	return zh_directory_ai_tools_studio_credits(inputs)
});
export { directory_ai_tools_studio_credits as "directory.ai_tools.studio.credits" }